<template>
  <div :class="keyboardClass" />
</template>

<script>
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';

export default {
  name: 'SimpleKeyboard',
  props: {
    keyboardClass: {
      default: 'simple-keyboard',
      type: String,
    },
    input: {
      default: '',
      type: String,
    },
    layout: {
      default: () => ({
        default: ['1 2 3', '4 5 6', '7 8 9', '0 {bksp}'],
      }),
      type: Object,
    },
    theme: {
      default: 'hg-theme-default hg-layout-numeric',
      type: String,
    },
    display: {
      default: () => ({ '{enter}': 'GO', '{back}': '⇦', '{bksp}': '⌫' }),
      type: Object,
    },
  },
  data: () => ({
    keyboard: null,
  }),
  watch: {
    input(input) {
      this.keyboard.setInput(input);
    },
  },
  mounted() {
    this.keyboard = new Keyboard(this.keyboardClass, {
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      layout: this.layout,
      display: this.display,
      theme: this.theme,
    });
    this.keyboard.setInput(this.input);
  },
  methods: {
    onChange(input) {
      this.$emit('onChange', input);
    },
    onKeyPress(button) {
      this.$emit('onKeyPress', button);
    },
  },
};
</script>
